import {
  RowSection,
  SkeletonBlock,
  mediaDesktopAndUp,
  mediaLargeScreens,
  mediaMinL,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

export const CouponLandingPageHeaderLoadingDesktop: React.FC<{
  className?: string;
}> = ({className}) => {
  return (
    <Container className={className}>
      <StyledSkeletonBlock />
    </Container>
  );
};

const Container = styled(RowSection)`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  height: 180px;
`;

const StyledSkeletonBlock = styled(SkeletonBlock)`
  --width: 70%;
  --padding: calc(2.7vw + 5px);

  width: calc(var(--width) - var(--padding));
  height: 100%;

  @media ${mediaDesktopAndUp} {
    --width: 80%;
  }

  @media ${mediaLargeScreens} {
    --width: 85%;
  }

  @media ${mediaMinL} {
    --width: 85%;
    --margin-right: 60px;
    --padding: 45px;
  }
`;
